import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=536847b3&scoped=true&"
import script from "./AppModal.vue?vue&type=script&lang=js&"
export * from "./AppModal.vue?vue&type=script&lang=js&"
import style0 from "./AppModal.vue?vue&type=style&index=0&id=536847b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536847b3",
  null
  
)

export default component.exports